import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { AuthService } from '../services/auth.service';
import { GuidelineService } from '../services/guideline.service';
import { ToastComponent } from '../shared/toast/toast.component';
import { Guideline } from '../shared/models/guideline.model';
import { ee, guidelineDepartments } from '../shared/constants';
import { removeTooltipElement } from '../shared/functions';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-guidelines',
  templateUrl: './guidelines.component.html',
  standalone: false
})
export class GuidelinesComponent implements OnInit, OnDestroy  {
  private guidelineService = inject(GuidelineService);
  auth = inject(AuthService);
  toast = inject(ToastComponent);


  guidelineDepartments = guidelineDepartments;
  isLoading = false;
  isEditGuidelineModalVisible = false;
  field = '';
  guideline: Guideline;
  guidelines: Guideline[] = [];
  guidelineAdded = false;
  canEditGuideline = false;
  // Filters
  titleFilter = '';
  departmentFilter = '';
  currentContent = 'documents';
  menuItems = [
    { name: 'Documents', link: 'documents', icon: 'book' },
    { name: '', link: '', icon: '' }, // Workaround to create a separator
    { name: 'Add new', link: 'add-new-document', icon: 'plus-circle' }, // Has permission, see ngOnInit
    { name: '', link: '', icon: '' }, // Workaround to create a separator
    { name: 'Welcome book', link: 'https://drive.google.com/file/d/1WRSdOS2po5Lym0zw-j5CFmNzcbMoT3yl/view?usp=sharing', icon: 'thumb-tack' },
    { name: 'Vademecum', link: 'https://drive.google.com/file/d/1HL7PuNGxIJB1EPILUk2_h_juaStE98dg/view?usp=share_link', icon: 'thumb-tack' },
    { name: 'I Valori', link: 'https://drive.google.com/file/d/1YyT71MczBVSV24lE-nymU0YcIkVS9D_u/view?usp=sharing', icon: 'thumb-tack' },
    { name: 'Il Metodo', link: 'https://drive.google.com/file/d/1RThqHXX41YRPgRZZN0MJ2AVaHud97nN0/view?usp=sharing', icon: 'thumb-tack' },
    { name: 'Corretta gestione clienti', link: 'https://drive.google.com/file/d/1Xo04EgkljmCzhtH-fdZ9gMcp6d5CJmiK/view?usp=sharing', icon: 'thumb-tack' },
    { name: 'Client coordinator', link: 'https://drive.google.com/file/d/1WX8w0h-9f7pV3uOq-Z2TUCzBLCYL-9KC/view?usp=sharing', icon: 'thumb-tack' },
    { name: 'Organigramma e seniority', link: 'https://drive.google.com/file/d/1W-VdF87vRkg90NuAOFt2x5oHd-Ui-jaK/view?usp=sharing', icon: 'thumb-tack' },
    { name: 'KPI valutazione team', link: 'https://drive.google.com/file/d/12gYSSNrGZY3TFjBHaavzDyD1-dpJ8D-j/view?usp=share_link', icon: 'thumb-tack' },
    { name: 'Codice etico e deontologico', link: 'https://drive.google.com/file/d/12jikB2217PG6rkseoEiPX-jA4fWssUqN/view?usp=share_link', icon: 'thumb-tack' },
    { name: 'Nella cucina di un ristorante stellato', link: 'https://drive.google.com/file/d/1Z9MeAglY9l_VzRnHfXna4gpajUj7SLMo/view?usp=sharing', icon: 'thumb-tack' },
  ];

  ngOnInit(): void {
    this.getGuidelines();
    this.canEditGuideline = this.auth.currentUser.permissions.includes('editGuideline');
    if (!this.canEditGuideline) {
      // Show this menu item only to those who can add new guidelines
      this.menuItems = this.menuItems.filter(menu => menu.link !== 'add-new-document');
    }
    ee.on('changeContent', (data: string) => {
      this.currentContent = data;
      this.guidelineAdded = false;
    });
    ee.on('getGuidelines', () => this.getGuidelines());
    ee.on('guidelineAdded', (guidelineAdded: boolean) => this.guidelineAdded = guidelineAdded);
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    ee.off('getGuidelines', () => {});
    ee.off('guidelineAdded', () => {});
    removeTooltipElement();
  }

  getGuidelines(): void {
    this.isLoading = true;
    this.guidelineService.getAll()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: res => this.guidelines = res,
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

  toggleEditGuidelineModal(guideline: Guideline): void {
    this.isEditGuidelineModalVisible = true;
    this.guideline = guideline;
    ee.emit('showEditGuidelineModal', guideline);
  }

  deleteGuideline(guideline: Guideline): void {
    if (window.confirm('Are you sure you want to delete this document?')) {
      this.isLoading = true;
      this.guidelineService.delete(guideline)
        .pipe(finalize(() => {
          this.getGuidelines();
          removeTooltipElement();
        }))
        .subscribe({
          next: res => this.toast.setMessage('Document deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }
}
